import Vue from "vue";
import Router from "vue-router";
const routerPush = Router.prototype.push;

Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => {});
};
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("../views/index.vue")
    },
    {
      path: "/ProductList",
      name: "ProductList",
      component: () => import("../views/ProductList.vue")
    },
    {
      path: "/InformationList",
      name: "InformationList",
      component: () => import("../views/InformationList.vue")
    },
    {
      path: "/WineCulture",
      name: "WineCulture",
      component: () => import("../views/WineCulture.vue")
    },
    {
      path: "/WineCultureBreed",
      name: "WineCultureBreed",
      component: () => import("../views/WineCultureBreed.vue")
    },
    {
      path: "/WineryDetails",
      name: "WineryDetails",
      component: () => import("../views/WineryDetails.vue")
    },
    {
      path: "/AboutUs",
      name: "AboutUs",
      component: () => import("../views/AboutUs.vue")
    },
    {
      path: "/ProductDetails",
      name: "ProductDetails",
      component: () => import("../views/ProductDetails.vue")
    },
    {
      path: "/InformationDetails",
      name: "InformationDetails",
      component: () => import("../views/InformationDetails.vue")
    },
    {
      path: "/WineryList",
      name: "WineryList",
      component: () => import("../views/WineryList.vue")
    },
    {
      path: "/PromotionCooperation",
      name: "PromotionCooperation",
      component: () => import("../views/PromotionCooperation.vue")
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js